import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Carousel from "react-material-ui-carousel";
import ContentCards from "../components/homepage/contentCards";
import CustomizedAccordions from "../components/homepage/accordion";
import CustomContainer from "../components/layout/container";
import CustomHeader from "../components/layout/header";

import windFarmOffshore from "../images/WindFarmOffshore_305_165.jpg";
// import whyIceberg from "../images/IcebergBlue_Original.jpg";
import OverseasStudentsUK from "../images/OverseasStudentsUK_305_165.jpg";
import EnerPriceHikes from "../images/EnerPriceHikes_Arrow_305_165.jpg";


const carouselHeight = "150px";
const RiskStoriesSubPage = () => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // const { whySubPage } = useParams();
  const { RiskStoriesSubPage } = useParams();

  const router = useNavigate();
  const [pageTitle, setPageTitle] = useState("");
  const [links, setLinks] = useState("");
  const [borderColorToHighlight, setborderColorToHighlight] = useState("");

  const getRouterData = () => {
//    if (whySubPage) {
    if (RiskStoriesSubPage) {
//       const url = whySubPage.replace(/-/g, " ");
      const url = RiskStoriesSubPage.replace(/-/g, " ");
      setLinks(url);
      const finalString = url.split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      setPageTitle(finalString);
      setTimeout(() => {
        setborderColorToHighlight(theme.palette.primary.dark);
      }, 100);
    }
  };

  const breadcrumbData = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: `RiskStories (${pageTitle})`,
      link: `/RiskStories/${RiskStoriesSubPage}`,
    },
  ];

  useEffect(() => {
    getRouterData();
  }, [RiskStoriesSubPage]);

  return (
    <Box>
      <Grid>
        <title>{pageTitle?.toUpperCase()} | MEF</title>
        <meta
          name="description"
          content="Identify & Quantify Macroeconomic/Esg risk"
        />
      </Grid>
      <CustomHeader
        title={`Risk Stories <span style="font-size:1.2rem;color:rgba(84,77,160,1);"> - Why Ignoring (Global) Economic/Energy Risks can be fatal</span>`}
        breadcrumbData={breadcrumbData}
      />

{/* MT-Gemini */}
      <Box sx={{ textAlign: 'left', my: 1, px:1 }}> {/* Added Box for placeholder styling */}
        <Typography variant="body1" color="rgba(84,77,160,1)">
          Below are 3 recent case studies of Industries/Sectors that neglected to perform adequate, forward-looking risk/scenario analysis and are now suffering
          significant, if not existential, consequences:
        </Typography>
      </Box>
      {/* End - MT-Gemini */}

      <CustomContainer>
        <Box >
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={windFarmOffshore}
                title="Offshore Wind Sector - US Fed Rate Shocks 2022"
                objectFit="fill"
                subTitle="Monetary Policy Shocks & Private CAPEX Risk Planning"
                borderColor={
                  links == "offshore wind" ? borderColorToHighlight : "none"
                }
                //example to link in text
                body={`Following the return to near-zero (Global) interest rates with the COVID pandemic, the US Fed subsequently shocked the Global economy by increasing its Federal Funds rate 
                  by 500bp - starting in early 2022 - to combat surging inflation driven by the Ukraine-war Global <b>energy price shock</b> ; rate hikes were partly responding to
                  the legacy of stimulatory US fiscal policy under COVID. This post-COVID sustained Fed tightening phase was the biggest Monetary Policy hike since 2004/05 & caught out many GreenTech & Wind Sector firms such as 
                  <b>Ørsted, Vattenfall, Equinor/BP, Iberdrola</b> & <b>Shell</b>.`}
              />
              <CustomizedAccordions
                title="Offshore Wind - High Fixed Costs"
                body={`The sector is characterised by <i>massive up-front fixed cost investments</i> with the expectation of lower, predictable operating costs and clean energy generation over subsequent decades.
                  Managing and reducing these high fixed costs through technological innovation, supply chain optimization, and efficient project execution is critical for the industry's continued growth and competitiveness.
                  Lifetime financing costs - particularly <i>early</i> in the project lifecycle - can represent a major threat to cash flow & corporate survival; it is <i>essential</i>
                  that any potential driver of (US) Monetary Policy tightening be anticipated in forward-looking sensitivity anlaysis.`}
              />
              <CustomizedAccordions
                title="How Macro Scenario Analysis can help ?"
                body={`We know that Global commodity price shocks are typical feature of the Global economic cycle so assuming they will <i>not</i> recur is a dangerous
                   assumption. MEF assist many different types of firm deal with the anticipation & quantification of Global or Sovereign risks/uncertainties that 
                   impact their domain-level operations across Economics, Globalisation/Trade, Finance, Investment and Energy/Emissions.
                One such firm is Decision Analysis Services Ltd which MEF have been working with MEF for almost 25 years; MEF assist DAS to model/quantify various Global, 
                conomic/Policy scenarios eg around Brexit transition, Trump's trade wars - see  <a href='/why/case-study/DAS'> Client Case Study - DAS</a>`}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={OverseasStudentsUK}
                title="UK University Sector - Ignoring Global Risk"
                subTitle={`Overseas Student Numbers-Fatal Over-Optimism`}
                borderColor={
                  links == "uk universities"  ? borderColorToHighlight : "none"
                }
                // <a href='/who/exporters' >
                body={` Over the last 10-15 years many UK Universities had become revenue-dependent on ongoing inflows of overseas students to the UK who pay 3 times the
                   tuition fees of domestic students. As admin-grade campus wage bills rose with the revenue boom - epitomised by the infamy of many "fatcat VCs"
                    with upto £1million compensation packages - the <i>implicit</i> (untested) assumption was that such a 'services export' boom would continue indefinately. Although 
                    bringing  the scaling benefits of expanded markets/demand, fully engaging the Global Economy in this way also brings <i>elevated risks</i> which must be 
                    monitored & mitigated with ongoing, forward-looking vigilance.`}  
              />
              <CustomizedAccordions
                title="From Boom to Bust; UK Regulator warns of University Closures"
                body={`The UK Educational Regulator - <b>Office for Students (OfS)</b> - warned in early 2025 that the risk of a large university in England
                   suddenly going bust has increased <i>significantly</i>, with the sector’s finances performing worse than expected in the second half of 2024.
                    The OfS modelled a drop of £3.4 billion n net income across the sector in 2025-26, due to poorer than expected student recruitment.
                    The number of <b>overseas students</b> in the UK <b>fell by almost 7% in the 2023-24</b> academic year, including a falls of 36% fall 
                    from Nigeria, 15% from India, with Chinese students down by 4%. Dundee University in Scotland, expects to now run out of cash by June 2025 
                    after a 27% drop international students;overseas students at Scottish Universities fell by more than 10,000 in 2023/2024 leaving many institutions 
                    exposed financially; a HE sector 'shake-out' now seems likely`}
              />
              <CustomizedAccordions
                title="A Highly Avoidable Financial Crisis in UK Education"
                body={`Whilst predicting (the timing of) "Black Swan" events is nigh-impossible, all <i>other</i>, known shocks (witnesed from recent economic history) gives us plenty
                  of reason & evidence to support <b>forward-vigilance via stress-testing (implicit) assumptions</b> around <i>all</i> key business revenue & cost drivers. Property price cycles - booms & busts - are
                  a regular feature of the Global Economy as recently occured in China. In order to explore the explicit downstream impacts of such macroeconomic & (asset) price shocks,
                  MEF has constructed <a title="student Global Econometric Model" href='/how/stuGEM-global-students'> stuGEM </a> a Global model of incoming student numbers to the UK that are driven by Global/National economic factors in the 
                  originating economies eg macro recovery/growth prospects in the Chinese & Indian economies. `}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={EnerPriceHikes}
                title="2022 Energy Price Hikes- Return of Global Inflation"
                subTitle={`Commodity Price Shocks Are a Feature, not a Bug`}
                borderColor={
                  links == "energy hikes"  ? borderColorToHighlight : "none"
                }
                body="Recent <b>Energy Sector</b> developments highligh both the risks - and opportunities presented by the Global Economy. The Ukraine conflict has arguably <i>increased</i> the urgency of <b>rapid Carbon transition</b> as Energy moves from
                the Economic/Corporate realm to that of existential National Security. As national Fiscal/Regulatory policy - outside the US - is likely to shift to accelerate Carbon transition, organisations need to
                be aware of their threats to their own transformation trajectories - and <b>Esg/Green Taxation exposure</b> - to both 2030 and 2050."
              />
              <CustomizedAccordions
                title="Industrial Level Analysis-Energy/Emissions"
                body="Industry-level detail within <a  title='macro Global Econometric Model'>mGEM</a>, allows MEF to monitor the feed-through of Global/National shocks to 12 industrial sectors (ISIC Rev. 4) across the majority of the 53 economies/zones covered by mGEM.
                In turn, <a title='energy Global Econometric Model' >enGEM</a> can then translate this industrial mix of output trajectories to build up an accurate projection of associated aggregate national GHG emissions to 2050.
                We can also overlay official <i>Energy use/supply</i> forecasts to 2050 in order to stress-test macroeconomic assumptions underlying these Official projections.
                Such scenario analysis can then test/explore alternative 'what-if' projections of both global/national/industrial activity and the associated GHG intensity of different activity projections."
              />
              <CustomizedAccordions
                title="GreenTech Shocks"
                body={`Technology has always been a key wildcard in any medium-term economic projections, moreso now in the "race" to hit challenging (and expanding) national climate
                legislative goals & targets for cleaner industrial/power sectors. MEF's global emissions forecasts are the product of (projections of) industrial sector output and associated
                GHG intensity trends. As the latter are generally judgementally projected, sectoral trends, they are  perfect candidates to test further in "GreenTech scenario analysis to compliment
                the more traditional macroeconomic sensitivity analysis on the demand-side.`}
              />
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default RiskStoriesSubPage;

// Mobile Apps and Webtools - powered by Global models/data
